/* Puplyo YouTube modal title/channel mask only */
(function(){
  document.addEventListener('click', function(e){
    var trigger = e.target.closest('[data-pup-video]');
    if (!trigger) return;
    setTimeout(function(){
      var modal = document.getElementById('PuplyoVideoModal');
      if (!modal) return;
      var box = modal.querySelector('[data-pup-video-box]');
      var iframe = box && box.querySelector('iframe[src*="youtube.com/embed"]');
      if (!box || !iframe || box.querySelector('[data-pup-youtube-mask]')) return;
      box.style.position = 'relative';
      box.style.overflow = 'hidden';
      var mask = document.createElement('span');
      mask.setAttribute('data-pup-youtube-mask', 'true');
      mask.setAttribute('aria-hidden', 'true');
      mask.style.cssText = 'position:absolute;top:0;left:0;right:0;height:170px;z-index:20;pointer-events:none;background:linear-gradient(to bottom,rgba(0,0,0,1) 0%,rgba(0,0,0,.98) 58%,rgba(0,0,0,.58) 82%,rgba(0,0,0,0) 100%);';
      box.appendChild(mask);
    }, 80);
  });
})();
